<template>
    <div class="menuTree" v-loading="loading">
        <el-tree class="ztree" node-key="id" ref="tree" :data="menuData" :props="defaultProps"
            :render-content="renderContent" :default-expanded-keys="defaultKeys" :current-node-key="nodeKey"
            :draggable="dragEnabled" :allow-drop="allowDrop"
            highlight-current accordion @node-click="handleNodeClick" @node-drop="handleDrop"></el-tree>
    </div>
</template>

<script>
import eventBus from '../bus';
import getPublic from '@/utils/getPublic.js';
import { pageOperateTree, pageOperateDetail, pageOperateDel, pageOperateBatchSort } from '@/api/modules/resoure.js'
export default {
    mixins: [getPublic],
    computed: {

    },
    components: {
        // 'v-aside':asideBar
    },
    data() {
        return {
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            defaultKeys: [],
            nodeKey: "",
            nodeName: "",
            /** parenData选中的父级数据 用于删除时候默认回退父级 如果是顶级则默认第一项 */
            parenData: "",
            menuData: [],
            loading: false,
            dragEnabled: true
        }
    },
    mounted() {
        this.initTree();
    },
    methods: {
        async initTree(row = null) {
            let id = null;
            if (row && row.id) {
                id = row.id
            }
            this.loading = true
            await pageOperateTree().then(({ result }) => {
                this.menuData = result;
                this.$nextTick(() => {
                    /** 小坑坑  注意一定使用$nectTick */
                    this.defaultKeys = [id || this.nodeKey || result[0].id]
                        ;
                    this.$refs.tree.setCurrentKey(id || this.nodeKey || result[0].id);
                });
                /** middle的默认 */
                eventBus.$emit('getMenuText', { row: row || result[0] });

                /** 模态框的默认选项 */
                this.$emit('chidrenDio', Object.assign({}, result[0], { parentId: "", name: this.nodeName || result[0].name }))

            }).finally(() => {
                setTimeout(() => {
                    this.loading = false
                }, 100)
            })

        },
        handleNodeClick(row, { data, parent }) {
            this.nodeKey = row.id;

            this.nodeName = row.name;

            this.parenData = parent;
            // this.detailFn(data.id)
            let text = null;
            const isZh = (this.$i18n.locale || '').indexOf('zh') === 0;
            const parentName = parent.data ? (isZh ? (parent.data.nameZh || parent.data.name) : (parent.data.nameEn || parent.data.name)) : '';
            const dataName = isZh ? (data.nameZh || data.name) : (data.nameEn || data.name);
            /** 区分是否是对象还是数组 */
            if (Object.prototype.toString.call(parent.data) === '[object Object]') {
                text = `${parentName} > ${dataName}`
            } else {
                text = `${dataName}`
            }
            /** 混入不行 provide也不行 vuex感觉大材小用了 */
            eventBus.$emit('getMenuText', { text, row, parentId: parent.data.id });
            this.$emit('chidrenDio', Object.assign({}, row, { parentId: parent.data.id, parentCode: parent.data.code }))
        },

        append(row, { data }) {
            this.$parent.isShow = true;
            this.$parent.title = 'buttonTitle.Edit';
            this.$parent.handleStatus = 'Edit';
            this.$parent.getPublicFn();
            this.$nextTick(() => {
                this.$parent.$refs.vForm.clearValidate()
                this.$parent.$refs.vForm.isMsg = false;
            })
            this.detailFn(row.id, { viewId: data.view, parentCode: data.parentCode })
        },
        remove(data) {
            this.TODOTIPDEL(data);
        },
        detailFn(id, obj) {
            pageOperateDetail({ id }).then(({ result }) => {
                const { name, nameZh, nameEn, code, enable, view, icon, id, url } = result;
                this.$parent.$refs.vForm.dioForm = {
                    name, nameZh, nameEn, code, enable, view: view + '', icon, type: 1, id, url
                };
                this.$parent.$refs.vForm.treeOBJ = {
                    ...obj
                };
            })
        },
        TODOTIPDEL(data) {
            this.$confirm(
                this.$t('messageTitle.DeleteToContinue'),
                this.$t('public.prompt'),
                {
                    confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                    cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                    type: 'warning',
                }
            ).then(() => {
                pageOperateDel({ ids: data.id }).then(({ state }) => {
                    if (state.code === 200) {
                        this.$message.success(this.$t('public.tip_del_succ').toString())
                        if (data.parentCode) {
                            this.nodeKey = this.parenData.data.id;
                        } else {
                            this.nodeKey = ""
                        }
                        this.initTree();
                    } else {
                        this.$message.error(state.msg)
                    }
                })
            }).catch(() => { })
        },
        renderContent(h, { node, data, store }) {
            const isZh = (this.$i18n.locale || '').indexOf('zh') === 0;
            const displayName = isZh ? (data.nameZh || data.name) : (data.nameEn || data.name);
            const iconClass = data.icon || 'el-icon-menu';
            return (
                <div class="custom-tree-node" style="width:100%;padding-right:15px">
                    <i class={iconClass}></i>
                    <span style="margin-left:5px">{displayName}</span>
                    <span style="float: right">
                        <i class="el-icon-edit icon" on-click={() => this.append(data, node)}></i>
                        <span>&nbsp;</span>
                        <i class="el-icon-delete icon" on-click={() => this.remove(data)}></i>
                    </span>
                </div>
            )

        },
        // 允许拖拽放置：只能同级排序（不允许跨父级移动，避免破坏菜单层级）
        allowDrop(draggingNode, dropNode, type) {
            // 只允许放在同级节点之前/之后，不允许放在节点内部（inner 会改变父级）
            if (type === 'inner') return false;
            // 父节点相同才允许
            const dragParent = draggingNode.parent.data.id || (draggingNode.parent.data.length ? 0 : draggingNode.parent.data.id);
            const dropParent = dropNode.parent.data.id || (dropNode.parent.data.length ? 0 : dropNode.parent.data.id);
            const dragPid = draggingNode.data.parentId || 0;
            const dropPid = dropNode.data.parentId || 0;
            return dragPid === dropPid;
        },
        // 拖拽完成后，一次性批量更新同级菜单的 sort_index
        async handleDrop(draggingNode, dropNode, dropType) {
            // 将同级所有子菜单的 id 和新顺序打包成数组，一次性发给后端
            const siblings = dropNode.parent.childNodes.map((n, idx) => ({
                id: n.data.id,
                sortIndex: idx + 1
            }));
            this.loading = true;
            try {
                const res = await pageOperateBatchSort(siblings);
                if (res.result === true) {
                    this.$message.success(this.$t('resource.sort_saved'));
                } else {
                    this.$message.error(this.$t('resource.sort_save_failed'));
                    this.initTree();
                }
            } catch (e) {
                console.error('[MenuTree] handleDrop error:', e);
                this.$message.error(this.$t('resource.sort_save_failed'));
                this.initTree();
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/tree.scss";

.menuTree {
    height: calc(100% - 60px);
    overflow: auto;
}

.custom-tree-node {
    width: 100%;
    display: flex;
    padding-right: 15px;
    box-sizing: border-box;
    justify-content: space-between;

    i {
        color: #c0c4cc;
        margin-right: 10px;
        font-size: 18px;

        &:hover {
            color: #c80101;
            font-weight: bold;
        }
    }
}

.ztree ::v-deep .el-tree-node.is-current>.el-tree-node__content i {
    color: #fff !important;
}
</style>
